// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"f4f02c87a226de48","5285":"1957101faaa0b96b"}[chunkId] + ".css";
};